import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eye, ShoppingCart, Users, TrendingUp, CheckCircle, Sparkles } from 'lucide-react';
const messages = [{
  icon: Eye,
  text: '47 personas están viendo este producto ahora',
  type: 'view'
}, {
  icon: ShoppingCart,
  text: 'Ana M. acaba de comprar Pack de Renovación',
  type: 'sale'
}, {
  icon: ShoppingCart,
  text: 'Lucía R. comenzó su renovación hace 6 minutos',
  type: 'sale'
}, {
  icon: ShoppingCart,
  text: 'Martina G. compró el pack hace 12 minutos',
  type: 'sale'
}, {
  icon: Users,
  text: '23 personas agregaron el pack al carrito hoy',
  type: 'view'
}, {
  icon: ShoppingCart,
  text: 'Florencia B. comenzó su transformación hace 8 minutos',
  type: 'sale'
}, {
  icon: TrendingUp,
  text: '156 personas compraron esta semana',
  type: 'view'
}, {
  icon: ShoppingCart,
  text: 'Gabriela S. acaba de acceder al pack completo',
  type: 'sale'
}, {
  icon: ShoppingCart,
  text: 'Romina P. comenzó su renovación hace 15 minutos',
  type: 'sale'
}, {
  icon: ShoppingCart,
  text: 'Valeria T. compró el pack hace 4 minutos',
  type: 'sale'
}, {
  icon: Eye,
  text: '62 personas están revisando los bonos ahora',
  type: 'view'
}, {
  icon: ShoppingCart,
  text: 'Natalia F. comenzó su proceso hace 10 minutos',
  type: 'sale'
}, {
  icon: CheckCircle,
  text: 'Paula C. completó su primera semana con éxito',
  type: 'success'
}, {
  icon: ShoppingCart,
  text: 'Jimena L. acaba de unirse al programa',
  type: 'sale'
}, {
  icon: Sparkles,
  text: '89 personas vieron resultados en la primera semana',
  type: 'view'
}, {
  icon: ShoppingCart,
  text: 'Celeste M. comenzó su cambio hace 3 minutos',
  type: 'sale'
}, {
  icon: Users,
  text: '34 personas están explorando los testimonios',
  type: 'view'
}, {
  icon: ShoppingCart,
  text: 'Micaela R. accedió al pack completo hace 7 minutos',
  type: 'sale'
}];
export function SocialProofWidget() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
    }, 15000);
    return () => clearInterval(timer);
  }, []);
  const CurrentIcon = messages[currentIndex].icon;
  return <div className="fixed bottom-4 left-4 z-50 max-w-[90vw] md:max-w-sm" data-id="element-12">
      <AnimatePresence mode="wait" data-id="element-13">
        <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-xl shadow-xl p-4 flex items-center gap-3 border border-gray-100" data-id="element-14">
          <div className={`p-2 rounded-full ${messages[currentIndex].type === 'view' ? 'bg-blue-100 text-blue-600' : messages[currentIndex].type === 'success' ? 'bg-purple-100 text-purple-600' : 'bg-green-100 text-green-600'}`} data-id="element-15">
            <CurrentIcon size={20} data-id="element-16" />
          </div>
          <p className="text-sm font-medium text-gray-800 leading-tight" data-id="element-17">
            {messages[currentIndex].text}
          </p>
        </motion.div>
      </AnimatePresence>
    </div>;
}